import React from 'react';

import { Outlet } from 'react-router';

import { PageLayout } from 'src/components/common';
import { ClearVerifyVerifiersDetailLayout } from 'src/layouts/ClearVerifyVerifiersDetailLayout';

export const VerifiersDetailOutlet: React.FC = () => {
  return (
    <PageLayout titleContent="Verifier Details" paperSx={{ mt: 5 }}>
      <ClearVerifyVerifiersDetailLayout>
        <Outlet />
      </ClearVerifyVerifiersDetailLayout>
    </PageLayout>
  );
};
